import { render, staticRenderFns } from "./NoContactsMessage.vue?vue&type=template&id=4f65ca91&"
import script from "./NoContactsMessage.vue?vue&type=script&lang=js&"
export * from "./NoContactsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports